import moment from "moment";
import { DataTableV2DateTypes } from "../preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";

export const dataTableV2DatesFilter = (format = "YYYY-MM-DD") => {
  const today = moment().format(format);
  const tommorow = moment().add(1, "days").format(format);
  const yesterday = moment().subtract(1, "days").format(format);
  const lastweek = moment().subtract(1, "weeks").format(format);
  const lastMonth = moment().subtract(1, "month").format(format);
  const last28Days = moment().subtract(28, "days").format(format);
  const last90Days = moment().subtract(90, "days").format(format);
  const last7Days = moment().subtract(6, "days").format(format);
  const currentDate = moment();
  const startDateOfMonth = currentDate.startOf("month").format(format);
  const thisWeekStartDate = moment().clone().startOf("isoWeek").format(format);
  const thisWeekEndDate = moment().clone().endOf("isoWeek").format(format);
  const allTimesStartDate = moment("2000-01-01").format(format);
  const last3Months = moment().subtract(3, "months").format(format);
  const startOfYear = moment().startOf("year").format(format);
  const last6Months = moment().subtract(6, "months").format(format);
  const lastYear = moment().subtract(1, "year").startOf("year").format(format);

  return {
    today,
    tommorow,
    yesterday,
    lastweek,
    thisWeekStartDate,
    thisWeekEndDate,
    lastMonth,
    last28Days,
    last90Days,
    last7Days,
    last6Months,
    startDateOfMonth,
    allTimesStartDate,
    last3Months,
    startOfYear,
    lastYear,
  };
};

export const getDataTablev2InitialDate = (
  type: DataTableV2DateTypes,
  format?: string,
) => {
  const {
    today,
    tommorow,
    lastweek,
    startDateOfMonth,
    yesterday,
    last28Days,
    last90Days,
    last6Months,
    last7Days,
    thisWeekStartDate,
    thisWeekEndDate,
    allTimesStartDate,
    last3Months,
    startOfYear,
    lastMonth,
    lastYear,
  } = dataTableV2DatesFilter(format);
  if (type === "yesterday") {
    return { fromDate: yesterday, toDate: yesterday };
  } else if (type === "lastWeek") {
    return { fromDate: lastweek, toDate: today };
  } else if (type === "thisMonth") {
    return { fromDate: startDateOfMonth, toDate: today };
  } else if (type === "last28Days") {
    return { fromDate: last28Days, toDate: today };
  } else if (type === "last90Days") {
    return { fromDate: last90Days, toDate: today };
  } else if (type === "last6Months") {
    return { fromDate: last6Months, toDate: today };
  } else if (type === "last7Days") {
    return { fromDate: last7Days, toDate: today };
  } else if (type === "thisWeek") {
    return { fromDate: thisWeekStartDate, toDate: thisWeekEndDate };
  } else if (type === "lastMonth") {
    return { fromDate: lastMonth, toDate: today };
  } else if (type === "last3Months") {
    return { fromDate: last3Months, toDate: today };
  } else if (type === "thisYear") {
    return { fromDate: startOfYear, toDate: today };
  } else if (type === "allTimes") {
    return { fromDate: allTimesStartDate, toDate: today };
  } else if (type === "lastYear") {
    return {
      fromDate: lastYear,
      toDate: moment()
        .subtract(1, "year")
        .endOf("year")
        .format(format || "YYYY-MM-DD"),
    };
  }

  return { fromDate: today, toDate: tommorow };
};
